import { motion } from "framer-motion";
import { EXCLUSIVITY } from "@/data/content";
import { Reveal } from "./primitives";

export default function ExclusivitySection() {
  return (
    <section className="relative overflow-hidden bg-brand-navy py-24 text-white md:py-36">
      <div className="noise-overlay pointer-events-none absolute inset-0 opacity-[0.05]" />
      <div className="pointer-events-none absolute inset-0">
        <div className="absolute left-1/2 top-0 h-[500px] w-[500px] -translate-x-1/2 rounded-full bg-brand-blue/25 blur-[140px]" />
        <div className="absolute bottom-0 right-10 h-72 w-72 rounded-full bg-brand-gold/12 blur-[120px]" />
      </div>
      {/* subtle tech lines */}
      <div className="pointer-events-none absolute inset-0 bg-[linear-gradient(to_right,rgba(255,255,255,0.04)_1px,transparent_1px)] bg-[size:80px_100%]" />

      <div className="relative mx-auto max-w-5xl px-5 text-center lg:px-8">
        <Reveal>
          <span className="text-[11px] font-semibold uppercase tracking-[0.3em] text-brand-gold">
            EXCLUSIVIDADE
          </span>
        </Reveal>
        <Reveal delay={0.1}>
          <h2 className="mx-auto mt-6 max-w-3xl font-display text-3xl font-semibold leading-[1.1] tracking-tight sm:text-4xl lg:text-5xl">
            Uma preparação específica para uma prova específica.
          </h2>
        </Reveal>
        <Reveal delay={0.2}>
          <p className="mx-auto mt-6 max-w-2xl text-base leading-relaxed text-white/60 md:text-lg">
            {EXCLUSIVITY.text}
          </p>
        </Reveal>

        <div className="mt-16 flex flex-col items-center justify-center gap-6 sm:flex-row sm:gap-12">
          {EXCLUSIVITY.pillars.map((p, i) => (
            <div key={p} className="flex items-center gap-6 sm:gap-12">
              <motion.span
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.7, delay: i * 0.12, ease: [0.16, 1, 0.3, 1] }}
                className="font-display text-3xl font-semibold tracking-tight gold-gradient-text animate-shimmer sm:text-4xl lg:text-5xl"
              >
                {p}
              </motion.span>
              {i < EXCLUSIVITY.pillars.length - 1 && (
                <span className="hidden h-2 w-2 rotate-45 bg-brand-gold/50 sm:block" />
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
